import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent, SpinnerComponent } from '@lib/components';
import { AngularMaterialModule } from 'src/app/material.module';
import { ApiResponseError, IAccount, ICustomer, ISearchTransactionResponse, ITransaction, ITransactionFilter, ITransactionIndex, IWallet } from '@lib/interfaces';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FilterMatcher, FilterOperator } from '@lib/enums';
import { ValueFieldModule } from '@lib/modules';
import { FormBuilder } from '@angular/forms';
import { BaseChartDirective, NgChartsModule } from 'ng2-charts';
import { ChartConfiguration, ChartOptions, ChartType } from 'chart.js';
import { MatDialog } from '@angular/material/dialog';
import { AccountsService, SidePanelService, TransactionService } from '@lib/services';
import { finalize } from 'rxjs';
import { TransactionTypePipe } from '@lib/pipes';
import { Router } from '@angular/router';
export enum Duration {
    Day = 'day',
    Month = 'month',
    Quarter = 'quarter',
    HalfYear = 'halfyear',
    Year = 'year',
}

export enum GraphType {
    Count = 'count',
    Amount = 'amount',
}

export enum Status {
    Approved = 'approved',
    Declined = 'declined',
    Settled = 'settled',
}

export interface ITransactionStatus {
    approved: ITransaction;
    declined: ITransaction;
    settled: ITransaction;
    value: string;
}
@Component({
    selector: 'app-neo-home',
    templateUrl: './nass-home.component.html',
    styleUrls: ['./nass-home.component.scss'],
    standalone: true,
    providers: [SidePanelService],
    imports: [AngularMaterialModule, NgChartsModule, SpinnerComponent, ValueFieldModule, TransactionTypePipe],
})
export class NassHomeComponent extends BaseComponent implements OnInit {
    @ViewChild(BaseChartDirective) canvas!: BaseChartDirective;
    accounts: IAccount[] = [];
    customer: ICustomer;
    customerId = localStorage.getItem('userId') ?? '';
    isLoading = true;
    walletForm = this.createWalletForm();

    // durations = [
    //     { key: 'day', value: 'Day' },
    //     { key: 'month', value: 'Month' },
    //     { key: 'quarter', value: 'Quarter' },
    //     { key: 'halfyear', value: 'Half Year' },
    //     { key: 'year', value: 'Year' },
    // ];

    selectedWallet = { currency: this.walletForm.controls.currency.value, balance: 0 };

    public lineChartData: ChartConfiguration['data'] = {
        datasets: [
            {
                data: [],
                label: 'Declined',
                backgroundColor: 'rgb(0 184 208 / 25%)',
                borderColor: '#06BDFC',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)',
                fill: true,
                pointRadius: 0,
                borderWidth: 2,
            },
            {
                data: [],
                label: 'Approved',
                backgroundColor: 'rgb(48 77 187 / 25%)',
                borderColor: '#7933FF',
                pointBackgroundColor: 'rgba(77,83,96,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(77,83,96,1)',
                fill: true,
                pointRadius: 0,
                borderWidth: 2,
            },
        ],
        labels: [],
    };
    public lineChartOptions: ChartOptions<any> = {
        responsive: true,
        aspectRatio: 3.5,
        elements: {
            line: {
                tension: 0.5,
            },
        },
        scales: {
            y: {
                position: 'left',
                grid: {
                    display: true,
                },
                beginAtZero: true,
                ticks: {
                    color: '#B5B5B5',
                },
            },
            x: {
                grid: {
                    display: false,
                },
                beginAtZero: true,
                ticks: {
                    color: '#68718F',
                },
            },
        },
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                    font: {
                        size: 10,
                    },
                },
            },
            datalabels: {
                formatter: () => {
                    return null;
                },
            },
            tooltip: {
                enabled: false,
                external(args: any) {
                    const { chart, tooltip } = args;
                    let tooltipEl = chart.canvas.parentNode.querySelector('div');

                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.style.background = 'white';
                        tooltipEl.style.borderRadius = '8px';
                        tooltipEl.style.boxShadow = '2px 3px 4px 0px #00000026';
                        tooltipEl.style.padding = '6px 8px';
                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.width = 'fit-content';
                        tooltipEl.classList.add('graph-tooltip');
                        chart.canvas.parentNode.appendChild(tooltipEl);
                    }

                    if (tooltip.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    if (tooltip.body) {
                        const approvedDiv = document.createElement('div');
                        approvedDiv.style.display = 'flex';
                        approvedDiv.style.alignItems = 'center';
                        const declinedDiv = document.createElement('div');
                        declinedDiv.style.display = 'flex';
                        declinedDiv.style.alignItems = 'center';
                        const dateTimeDiv = document.createElement('div');
                        dateTimeDiv.style.fontSize = '9px';
                        dateTimeDiv.style.fontWeight = '500';
                        dateTimeDiv.style.lineHeight = '10.8px';
                        dateTimeDiv.style.color = '#68718F';
                        dateTimeDiv.style.marginTop = '2px';

                        const approvedTitle = document.createElement('div');
                        approvedTitle.style.marginRight = '2px';
                        approvedTitle.style.fontSize = '14px';
                        approvedTitle.style.fontWeight = '500';
                        approvedTitle.style.lineHeight = '17.07px';
                        approvedTitle.style.color = '#304DBB';

                        const approvedAmount = document.createElement('div');
                        approvedAmount.style.fontWeight = '700';
                        approvedAmount.style.color = '#020E3D';

                        const declinedTitle = document.createElement('div');
                        declinedTitle.style.marginRight = '2px';
                        declinedTitle.style.fontSize = '14px';
                        declinedTitle.style.fontWeight = '500';
                        declinedTitle.style.lineHeight = '17.07px';
                        declinedTitle.style.color = '#00B8D0';

                        const declinedAmount = document.createElement('div');
                        declinedAmount.style.fontWeight = '700';
                        declinedAmount.style.color = '#020E3D';

                        const index = tooltip.dataPoints[0].dataIndex;

                        const declinedTitleValue: string = chart.data.datasets[0].label;
                        declinedTitle.innerText = declinedTitleValue + ':';

                        const declinedAmountValue = chart.data.datasets[0].data[index];
                        declinedAmount.innerText = declinedAmountValue;

                        const approvedTitleValue: string = chart.data.datasets[1].label;
                        approvedTitle.innerText = approvedTitleValue + ':';

                        const approvedAmountValue = chart.data.datasets[1].data[index];
                        approvedAmount.innerText = approvedAmountValue;

                        approvedDiv.appendChild(approvedTitle);
                        approvedDiv.appendChild(approvedAmount);
                        declinedDiv.appendChild(declinedTitle);
                        declinedDiv.appendChild(declinedAmount);
                        while (tooltipEl.firstChild) {
                            tooltipEl.firstChild.remove();
                        }

                        tooltipEl.appendChild(approvedDiv);
                        tooltipEl.appendChild(declinedDiv);
                        tooltipEl.appendChild(dateTimeDiv);
                    }

                    const { offsetLeft: positionX, offsetTop: positionY }: { offsetLeft: number; offsetTop: number } = chart.canvas;
                    tooltipEl.style.opacity = 1;
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
                    tooltipEl.style.font = tooltip.options.bodyFont.string;
                },
            },
        },
    };
    public lineChartType: ChartType = 'line';
    protected wallets: any = [];
    protected transactions: ITransactionIndex[] = [];
    protected transactionLoading = true;
    protected transactionGraphLoading = true;
    protected currentDate = new Date();

    constructor(
        private readonly accountsService: AccountsService,
        private readonly snackbar: MatSnackBar,
        protected readonly formBuilder: FormBuilder,
        private readonly dialog: MatDialog,
        private readonly transactionService: TransactionService,
        private readonly router: Router,
        private readonly sidePanel: SidePanelService,
    ) {
        super();
    }

    ngOnInit() {
        this.filters;
        this.fetchCustomerAccounts();
        this.searchTransactions();
        this.fetchTransactionsCount();
        this.addSubscription(
            this.accountsService.reloadWalletList.subscribe({
                next: (value: any) => {
                    if (value) {
                        this.fetchCustomerAccounts();
                    }
                },
            }),
        );
        this.walletForm.controls.currency.valueChanges.subscribe((value) => {
            this.selectedWallet.currency = value;
        });

        // this.walletForm.controls.duration.valueChanges.subscribe((value) => {
        //     this.fetchTransactionsCount(value);
        // });
    }

    fetchCustomerAccounts() {
        this.accountsService.getAccountsByUserId(this.customerId).subscribe({
            next: ({ data: accounts }) => {
                if (accounts.length === 0) {
                    this.isLoading = false;
                    return;
                }

                const uniqueBalances = new Map();

                accounts.forEach((account: IAccount) => {
                    const currency = Object.keys(account.balances)[0];
                    const balance = account.balances[currency];
                    uniqueBalances.set(currency, balance);
                });

                this.wallets = Array.from(uniqueBalances, ([currency, balance]) => ({
                    currency,
                    balance,
                    selected: currency === this.walletForm.controls.currency.value,
                }));

                this.selectedWallet = this.wallets.find((wallet: any) => wallet.currency === this.walletForm.controls.currency.value) || { currency: this.walletForm.controls.currency.value, balance: 0, selected: true };

                this.wallets = this.wallets.map((wallet: any) => ({
                    ...wallet,
                    selected: wallet.currency === this.selectedWallet.currency,
                }));

                this.accounts = accounts;
                this.isLoading = false;
            },
            error: (error: ApiResponseError) => {
                this.isLoading = false;
                this.createApiErrorSnackBar(this.snackbar, error);
            },
        });
    }

    protected get filters(): Array<ITransactionFilter> {
        return [
            {
                field: 'user_id',
                operator: FilterOperator.ALL_OF,
                values: [this.customerId],
            },
            {
                field: 'status_code',
                operator: FilterOperator.ALL_OF,
                values: ['0000'],
            },
        ];
    }

    protected createWalletForm() {
        return this.formBuilder.group({
            currency: this.formBuilder.nonNullable.control('USD'),
            duration: this.formBuilder.nonNullable.control(this.currentDate),
        });
    }

    protected changeWallet(selectedWalled: string) {
        const wallet = this.wallets.find((wallet: IWallet) => wallet.currency === selectedWalled);

        this.selectedWallet = wallet;
    }

    getInitials(names: string): string {
        const namesArray = names.split(' ');
        const initials = namesArray.map((name) => name.charAt(0).toUpperCase()).join('');
        return initials;
    }

    protected searchTransactions(): void {
        this.addSubscription(
            this.transactionService
                .searchTransactions({ limit: 50, filters: this.filters, matcher: FilterMatcher.AND })
                .pipe(
                    finalize((): void => {
                        this.transactionLoading = false;
                    }),
                )
                .subscribe({
                    next: ({ data }: ISearchTransactionResponse): void => {
                        this.transactions = data;
                    },
                    error: (error: ApiResponseError): void => {
                        this.transactionLoading = false;
                        this.createApiErrorSnackBar(this.snackbar, error);
                    },
                }),
        );
    }

    fetchTransactionsCount(duration = 'month'): void {
        this.transactionGraphLoading = true;
        this.addSubscription(
            this.transactionService.fetchTransactionsCount(duration).subscribe({
                next: (response: any) => {
                    if (response) {
                        this.transactionGraphLoading = true;
                        this.renderGraph(response);
                    }
                },
                error: () => {
                    this.transactionGraphLoading = false;
                },
            }),
        );
    }

    renderGraph(response: any, graphType: GraphType = GraphType.Amount): void {
        const labels: string[] = [];
        const txnData: { approved: any[]; declined: any[]; settled: any[] } = {
            approved: [],
            settled: [],
            declined: [],
        };

        response.details.data.map((txn: ITransactionStatus) => {
            labels.push(this.formatDate(txn.value));

            txnData.approved.push(Number(txn.approved[graphType]));
            txnData.declined.push(Number(txn.declined[graphType]));
        });

        this.lineChartData.datasets[0].data = txnData.declined;
        this.lineChartData.datasets[1].data = txnData.approved;
        this.lineChartData.labels = [...labels];

        this.canvas?.update();
        this.transactionGraphLoading = false;
    }

    formatDate(date: string) {
        if (date.length === 6) {
            return `${new Date(date.substring(0, 2)).toLocaleString('en-US', { month: 'short' })} ${date.substring(2, date.length)}`;
        }
        if (date.length === 8) {
            const currentDate = `${date.substring(2, 4)}/${date.substring(0, 2)}/${date.substring(4, date.length)}`;
            const formattedDate = new Date(currentDate).toLocaleString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            });
            return formattedDate;
        }
        throw new Error('Invalid date format');
    }
}
